import {
  putProcedure,
  postProcedure,
  getAllProcedure,
  deleteProcedure,
  getProcedureById,
} from '@/fetchApi/MasterData/Procedure';

const state = {
  dashboard: {
    dialog: false,
    filter: {
      halaman: 0,
      itemCount: 0,
      sortBy: '',
      keyword: '',
    },
  },
  items: {
    dataProcedure: {
      isLoading: false,
      data: [],
    },
  },
  form: {
    id: '',
    code: '',
    description: '',
  },
};
const getters = {
  // Get State Dialog
  getDialog: state => state.dashboard.dialog,

  // Get State Items
  getItems: state => state.items,

  // Get State Form
  getForm: state => state.form,
};
const mutations = {
  // Set State Dialog
  setDialog(state, payload) {
    state.dashboard.dialog = payload;
  },

  // Set State Items
  setItems(state, payload) {
    const { label, value, isLoading } = payload;
    state.items[label] = {
      ...state[label],
      data: value,
      isLoading,
    };
  },

  // Set State Form
  setForm(state, payload) {
    state.form = payload;
  },

  // Set Filter
  setFilter(state, payload) {
    state.dashboard.filter = payload;
  },

  // Clear Form
  clearForm(state) {
    state.form = {
      id: '',
      code: '',
      description: '',
    };
  },
};
const actions = {
  // Get Data
  // Gett All Data Drugs
  async resolveGetAllProcedure(
    { commit, state },
    { halaman, itemCount, sortBy, keyword },
  ) {
    commit('setItems', {
      label: 'dataProcedure',
      value: [...state.items.dataProcedure.data],
      isLoading: true,
    });
    try {
      const params = {
        search: keyword || '',
        page: halaman,
        itemCount,
        sort: sortBy,
      };
      const procedureResponse = await getAllProcedure(params);

      const procedureMapper = procedureResponse?.data?.map(item => ({
        id: item._id.toString(),
        code: item.code.toString(),
        description: item.description,
      }));
      commit('setItems', {
        label: 'dataProcedure',
        value: procedureMapper,
        isLoading: false,
      });
      return procedureResponse?.length;
    } catch {
      commit('setItems', {
        label: 'dataProcedure',
        value: [],
        isLoading: false,
      });
      return 0;
    }
  },

  // Get Data Procedure By Id
  async resolveGetProcedureById({ state, commit }) {
    const responseGetProcedureById = await getProcedureById(state.form.id);
    try {
      commit('setForm', {
        id: responseGetProcedureById._id,
        code: responseGetProcedureById.code,
        description: responseGetProcedureById.description,
      });
      return responseGetProcedureById;
    } catch (error) {
      return error;
    }
  },
  // End Get Data

  // Post Data
  async resolvePostProcedure({ state, commit, dispatch }) {
    const payload = {
      ...state.form,
    };
    delete payload.id;

    try {
      const postProcedureRes = await postProcedure(payload);
      if (postProcedureRes.status === 200) {
        commit('setDialog', false);
        commit('clearForm');
        await dispatch('resolveGetAllProcedure', {
          ...state.dashboard.filter,
        });
      }
      return postProcedureRes.status;
    } catch (error) {
      return error;
    }
  },
  // End Post Data

  // Put Data
  async resolvePutProcedure({ state, commit, dispatch }) {
    const payload = {
      ...state.form,
    };
    delete payload.id;

    try {
      const putProcedureRes = await putProcedure(state.form.id, payload);
      if (putProcedureRes.status === 200) {
        commit('setDialog', false);
        commit('clearForm');
        await dispatch('resolveGetAllProcedure', {
          ...state.dashboard.filter,
        });
      }
      return putProcedureRes.status;
    } catch (error) {
      return error;
    }
  },
  // End Put Data

  // Delete Data
  async resolveDeleteProcedure(_, id) {
    try {
      const responseDeleteProcedure = await deleteProcedure(id);
      return responseDeleteProcedure;
    } catch (error) {
      return error;
    }
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};
